// File: src/components/Blog/PublicSocialShare.jsx
import React, { useState } from 'react';
import {
  FaFacebook,
  FaXTwitter,
  FaInstagram,
  FaWhatsapp,
  FaTelegram,
  FaLinkedin,
  FaLink,
} from 'react-icons/fa6';

export default function PublicSocialShare({
  url,
  title = 'Million2Trillion Blog',
  showLabel = true,
  size = 20,
  className = '',
}) {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const text = encodeURIComponent(title);
  const href = encodeURIComponent(shareUrl);

  const fb = `https://www.facebook.com/sharer/sharer.php?u=${href}`;
  const x  = `https://twitter.com/intent/tweet?url=${href}&text=${text}`;
  // Instagram has no web share-for-link; this just opens instagram.com (let users post manually)
  const ig = `https://www.instagram.com/`;
  const wa = `https://api.whatsapp.com/send?text=${text}%20${href}`;
  const tg = `https://t.me/share/url?url=${href}&text=${text}`;
  const li = `https://www.linkedin.com/feed/?shareActive=true&shareUrl=${href}`;

  const [copied, setCopied] = useState(false);
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {}
  };

  return (
    <div className={`flex items-center gap-4 flex-wrap ${className}`}>
      {showLabel && (
        <span className="text-sm md:text-base text-gray-400">Share to:</span>
      )}

      <a href={fb} target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook"
         className="hover:scale-110 transition-transform"><FaFacebook size={size} /></a>
      <a href={x}  target="_blank" rel="noopener noreferrer" aria-label="Share on X"
         className="hover:scale-110 transition-transform"><FaXTwitter size={size} /></a>
      <a href={ig} target="_blank" rel="noopener noreferrer" aria-label="Open Instagram"
         className="hover:scale-110 transition-transform"><FaInstagram size={size} /></a>
      <a href={wa} target="_blank" rel="noopener noreferrer" aria-label="Share on WhatsApp"
         className="hover:scale-110 transition-transform"><FaWhatsapp size={size} /></a>
      <a href={tg} target="_blank" rel="noopener noreferrer" aria-label="Share on Telegram"
         className="hover:scale-110 transition-transform"><FaTelegram size={size} /></a>
      <a href={li} target="_blank" rel="noopener noreferrer" aria-label="Share on LinkedIn"
         className="hover:scale-110 transition-transform"><FaLinkedin size={size} /></a>

      <button
        type="button"
        onClick={copyLink}
        aria-label="Copy link"
        className="hover:scale-110 transition-transform"
        title={copied ? 'Copied!' : 'Copy link'}
      >
        <FaLink size={size} />
      </button>
    </div>
  );
}
